import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import type { UserInfoResponse } from '@account/models';
import { toCamelcase } from '@essent/core-utils';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@core/config-angular';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  loadUserInfo(): Observable<UserInfoResponse> {
    return this.http
      .get(`${this.appConfigService.basePath}/auth/userinfo`)
      .pipe(toCamelcase<UserInfoResponse>());
  }

  constructor(
    private readonly http: HttpClient,
    private readonly appConfigService: AppConfigService
  ) {}
}
